<template>
    <div style="margin: 16px;">

        <div style="background:white; padding: 16px; direction:rtl; max-width: 800px; margin: auto;">


            <!-- 1) tq info -->
            <table style="width:100%;">
                <tr>
                    <td>
                        <div> טרבל קווסט</div>
                        <div>ח"פ 303035596</div>
                        <div>dan@travelAndQuest.com</div>
                        <div>ישראל, לוד, דני מס 1</div>
                    </td>
                    <td style="text-align: left">
                        <img style="border-radius: 5px" src="https://firebasestorage.googleapis.com/v0/b/travelquest-da6b2.appspot.com/o/TQ%2Fapple-touch-icon-120x120.png?alt=media&token=ded9d127-7038-4b0d-8e4c-de571e6eabba"/>
                    </td>
                </tr>
            </table>

            <!-- 2) email title -->
            <div style="margin: 12px 0px; border-bottom: 2px solid #885ead; "></div>

            <div style="font-size: 28px; margin-bottom: 8px;">
                סיכום חודש - עומר - ספטמבר 2020
            </div>

            <div style="margin: 12px 0px; border-bottom: 2px solid #885ead; "></div>


            <!-- 3) sold tickets -->
            <div style="font-size: 24px; margin: 8px 0px;background: #2E294E; color: white; padding: 8px 0px"> כרטיסים שנמכרו דרך החנות:</div>

            <div style="overflow-x: auto">
                <table style="border: 1px solid black;border-collapse: collapse; box-sizing: border-box;  width:100%; text-align: center">

                    <tr style="background: #bba3d0; font-weight: bold; font-size: 20px;">
                        <td style='border: 1px solid black; font-weight: bold; padding: 8px;'>מספר כרטיס</td>
                        <td style='border: 1px solid black; font-weight: bold; padding: 8px;'>תאריך רכישה</td>
                        <td style='border: 1px solid black; font-weight: bold; padding: 8px;'>מחיר</td>
                        <td style='border: 1px solid black; font-weight: bold; padding: 8px;'>שם האירוע</td>
                        <td style='border: 1px solid black; font-weight: bold; padding: 8px;'>תאריך האירוע</td>
                        <td style='border: 1px solid black; font-weight: bold; padding: 8px;'>סטטוס</td>
                        <td style='border: 1px solid black; font-weight: bold; padding: 8px;'>סוכן</td>
                    </tr>
                    <tr>
                        <td style="border: 1px solid black; padding: 8px;">9b6d9389-eb35-4468-b93c-c21097a87863</td>
                        <td style="border: 1px solid black; padding: 8px;">1/1/2018 13:30*</td>
                        <td style="border: 1px solid black; padding: 8px;">10₪ </td>
                        <td style="border: 1px solid black; padding: 8px;">Night Hunt</td>
                        <td style="border: 1px solid black; padding: 8px;">1/1/2018 13:30*</td>
                        <td style="border: 1px solid black; padding: 8px;">פג תוקף</td>
                        <td style="border: 1px solid black; padding: 8px;">123</td>
                    </tr>
                    <tr>
                        <td style="border: 1px solid black; padding: 8px;">9b6d9389-eb35-4468-b93c-c21097a87863</td>
                        <td style="border: 1px solid black; padding: 8px; ">1/1/2018 13:30*</td>
                        <td style="border: 1px solid black; padding: 8px;">10₪ </td>
                        <td style="border: 1px solid black; padding: 8px;">Night Hunt</td>
                        <td style="border: 1px solid black; padding: 8px; ">1/1/2018 13:30*</td>
                        <td style="border: 1px solid black; padding: 8px;">אושר</td>
                        <td style="border: 1px solid black; padding: 8px;">123</td>
                    </tr>
                    <tr>
                        <td style="border: 1px solid black; padding: 8px;">9b6d9389-eb35-4468-b93c-c21097a87863</td>
                        <td style="border: 1px solid black; padding: 8px; ">1/1/2018 13:30*</td>
                        <td style="border: 1px solid black; padding: 8px;">10₪ </td>
                        <td style="border: 1px solid black; padding: 8px;">Night Hunt</td>
                        <td style="border: 1px solid black; padding: 8px; ">1/1/2018 13:30*</td>
                        <td style="border: 1px solid black; padding: 8px;">בוטל</td>
                        <td style="border: 1px solid black; padding: 8px;">-</td>
                    </tr>

                </table>
            </div>
            <div style="display: inline-block; margin-top: 4px"> <b>*איזור זמן:</b> GMT+0200</div>

            <div style="font-size: 20px; margin: 8px 0px;">
                ב-10 לחודש יועבר
                <b>
                    22 ש"ח, ו-8 דולר
                </b>
                <div>
                    לבנק "לאומי", סניף "123", חשבון "12345678"
                </div>
            </div>

            <div style="margin: 12px 0px; border-bottom: 2px solid #885ead; "></div>


            <!-- 4) requested tickets -->
            <div style="font-size: 24px; margin: 32px 0px 8px;background: #2E294E; color: white; padding: 8px 0px">כרטיסים שנוצרו על ידי יוצר הקווסט:</div>

            <div style="overflow-x: auto">
                <table style="border: 1px solid black;border-collapse: collapse; box-sizing: border-box;  width:100%; text-align: center">

                    <tr style="background: #bba3d0; font-weight: bold; font-size: 20px;">
                        <td style='border: 1px solid black; font-weight: bold; padding: 8px;'>מספר כרטיס</td>
                        <td style='border: 1px solid black; font-weight: bold; padding: 8px;'>תאריך רכישה</td>
                        <td style='border: 1px solid black; font-weight: bold; padding: 8px;'>מחיר</td>
                        <td style='border: 1px solid black; font-weight: bold; padding: 8px;'>שם האירוע</td>
                        <td style='border: 1px solid black; font-weight: bold; padding: 8px;'>תאריך האירוע</td>
                        <td style='border: 1px solid black; font-weight: bold; padding: 8px;'>כניסות</td>
                        <td style='border: 1px solid black; font-weight: bold; padding: 8px;'>מידע נוסף</td>
                    </tr>
                    <tr>
                        <td style="border: 1px solid black; padding: 8px;">9b6d9389-eb35-4468-b93c-c21097a87863</td>
                        <td style="border: 1px solid black; padding: 8px;">1/1/2018 13:30*</td>
                        <td style="border: 1px solid black; padding: 8px;">10₪ </td>
                        <td style="border: 1px solid black; padding: 8px;">Night Hunt</td>
                        <td style="border: 1px solid black; padding: 8px;">1/1/2018 13:30*</td>
                        <td style="border: 1px solid black; padding: 8px;">10/20</td>
                        <td style="border: 1px solid black; padding: 8px;">יצרנו את הכרטיס הזה על ידי בלה בלו</td>
                    </tr>
                    <tr>
                        <td style="border: 1px solid black; padding: 8px;">9b6d9389-eb35-4468-b93c-c21097a87863</td>
                        <td style="border: 1px solid black; padding: 8px; ">1/1/2018 13:30*</td>
                        <td style="border: 1px solid black; padding: 8px;">10₪ </td>
                        <td style="border: 1px solid black; padding: 8px;">Night Hunt</td>
                        <td style="border: 1px solid black; padding: 8px; ">1/1/2018 13:30*</td>
                        <td style="border: 1px solid black; padding: 8px;">10/12</td>
                        <td style="border: 1px solid black; padding: 8px;">יצרנו את הכרטיס הזה על ידי בלה בלו</td>
                    </tr>
                    <tr>
                        <td style="border: 1px solid black; padding: 8px;">9b6d9389-eb35-4468-b93c-c21097a87863</td>
                        <td style="border: 1px solid black; padding: 8px; ">1/1/2018 13:30*</td>
                        <td style="border: 1px solid black; padding: 8px;">10₪ </td>
                        <td style="border: 1px solid black; padding: 8px;">Night Hunt</td>
                        <td style="border: 1px solid black; padding: 8px; ">1/1/2018 13:30*</td>
                        <td style="border: 1px solid black; padding: 8px;">5/5</td>
                        <td style="border: 1px solid black; padding: 8px;">יצרנו את הכרטיס הזה על ידי בלה בלו</td>
                    </tr>

                </table>
            </div>
            <div style="display: inline-block; margin-top: 4px"> <b>*איזור זמן:</b> GMT+0200</div>

            <div style="font-size: 20px; margin: 8px 0px;">
                יצרת החודש
                <b>120 כרטיסים</b>,
                 כרטיס האשראי שמסתיים ב xxxxxxx1234 יחויב ב
                <b> 120 דולר,</b>
                ב-10 לחודש
            </div>

            <div style="margin: 12px 0px; border-bottom: 2px solid #885ead; "></div>




        </div>
    </div>
</template>

<script>
    export default {
        name: "v_EmailCreatorMonthSummary"
    }
</script>

<style scoped>
</style>